import React from "react";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Input from "@mui/material/Input";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";

import Snackbar from "@mui/material/Snackbar";
import CloseIcon from "@mui/icons-material/Close";

function Iban() {
  const _iban = "IT72 U036 6901 6002 3596 9270 990";

  const handleClick = (e) => {
    navigator.clipboard.writeText(_iban);
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const [open, setOpen] = React.useState(false);
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <FormControl
      sx={{ m: 1, paddingTop: "20px", paddingBottom: "20px" }}
      fullWidth
      variant="standard"
    >
      <Input
        id="filled-adornment-password"
        type="text"
        disabled
        sx={{ width: "95%", color: "#fff" }}
        InputLabelProps={{ color: "#fff" }}
        value={_iban}
        endAdornment={
          <InputAdornment position="end">
            <Tooltip title="copia">
              <IconButton
                aria-label="toggle password visibility"
                edge="end"
                color="secondary"
                sx={{ color: "#fff" }}
                onClick={handleClick}
              >
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
          </InputAdornment>
        }
      />
      <Input
        id="filled-adornment-password"
        type="text"
        disabled
        sx={{ width: "95%", color: "#fff" }}
        InputLabelProps={{ color: "#fff" }}
        value={"Intestato a Erica Maglio"}
      />

      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        message="IBAN Copiato"
        action={action}
      />
    </FormControl>
  );
}

export default Iban;
